import {CustomerModel} from './customer.model';

export class OwnershipCustomerRelationshipModel {
    public id: number;
    public customerNumberID: number;
    public customerNameID: number;
    public vehicleOwnershipID: number;
    public ownershipRoleTypeID: number;
    public legalStatusTypeID: number;
    public registrationMailTo: boolean;
    public titleMailTo: boolean;
    public ownershipRoleSequence: number;
    public ownershipCustomerRelationshipStatusTypeId: number;
    public mailingAddress: string;
    public customer: CustomerModel;
    public physicalAddressEmissionTypeAreaTypeID: number;
}
